// import {ItemConfigs} from "./items/itemConfigs";

const ShopCardMv = 'b_sailor_c_20u5x6mu_mv';

const ShopCardMc = 'b_sailor_c_20u5x6mu_mc';

const ShopCardProductMv = 'b_sailor_c_n7vcwalw_mv';
const ShopCardProductMc = 'b_sailor_c_n7vcwalw_mc';

export interface LxFilterParams {
  sort_code: string;
  sort_name: string;
  filter_code: string;
  filter_name: string;
}

const Statistics = Mach.requireModule('Statistics');

// const shopActivity = {
//     fullReduction : 2, // 满减
//     fullDiscountActivity: 3, // 满折
//     feeFree:4, // 免配送费
//     promoDishes: 18, // 折扣菜
//     deliveryActivity: 21, // 配送费活动
// }

const contentItemLxMap = {
  shopScore(data = {}) {
    return { shop_rating: data?.shopScoreInfo?.score || '-999', };
  },
  deliveryTime(data = {}) {
    return { delivery_time: data?.deliveryTimeDesc || '-999', };
  },
  distance(data = {}) {
    return { shop_distance: data?.distance?.desc || '-999', };
  },
  deliveryFee(data = {}) {
    return {
      currency_type: data?.deliveryFee?.currency || data?.finalDeliveryFee?.currency,
      delivery_price: data?.finalDeliveryFeeInfo?.price?.displayText || data?.deliveryFee?.displayText || '-999',
    };
  },
  minCostPrice(data = {}) {
    return { min_price: data?.minCostPrice?.displayAmount || '-999', };
  }
};

function handleContentLxParams(data: any) {
  let paramsLxForLogs = {};

  const shopContentVerticalData = data?.content || [];
  shopContentVerticalData.forEach((item: any) => {
    item.forEach((subItem: any) => {
      const itemType = subItem.type;
      const paramsForLxLog = contentItemLxMap[itemType];
      const lxParams = paramsForLxLog?.();
      if (lxParams) {
        paramsLxForLogs = { ...paramsLxForLogs, ...lxParams };
      }
    });
  });
  return paramsLxForLogs;
}

// 灵犀埋点上报参数处理
export const handleLXParam = (data: any, shop_index: number, bizTraceId: string, lxFilterParams: LxFilterParams) => {
  const logData = data?.logData || {};
  const contentLxParams = handleContentLxParams(data);
  return {
    filter_code: lxFilterParams?.filter_code || '-999',
    filter_name: lxFilterParams?.filter_name || '-999',
    sort_code: lxFilterParams?.sort_code || '-999',
    sort_name: lxFilterParams?.sort_name || '-999',

    currency_type: '-999',
    delivery_price: '-999',
    delivery_time: '-999',
    shop_distance: '-999',
    min_price: '-999',
    shop_rating: '-999',

    picture_url: data?.shopMainPicUrl || '-999',
    spu_cnt: data?.subCards?.length || 0,

    shop_id: '-999',
    shop_index,

    shop_status: data?.shopStatus?.shopStatusCode || '-999',
    tab_key: '-999',
    user_get_mode: 'delivery',
    ...contentLxParams,
    ...logData,
  };
};

export const reportProductCardMc = (cid: string, data: any, shop_index: number, bizTraceId: string, lxFilterParams: LxFilterParams, pageLogData: any) => {
  if (!cid) {
    return;
  }
  const params = handleLXParam(data, shop_index, bizTraceId, lxFilterParams);
  const finalParam = {
    ...params,
    ...pageLogData,
  };
  Statistics.setTag && Statistics.setTag('sailor_c', {
    [cid]: {
      ...finalParam,
      bid: ShopCardMc,
    },
  });
  Statistics.click(cid, ShopCardMc, finalParam);
};

export const reportProductCardMv = (cid: string, data: any, shop_index: number, bizTraceId: string, lxFilterParams: LxFilterParams, pageLogData: any) => {
  if (!cid) {
    return;
  }
  const params = handleLXParam(data, shop_index, bizTraceId, lxFilterParams);
  const finalParam = {
    ...params,
    ...pageLogData,
  };
  Statistics.view(cid, ShopCardMv, finalParam);
};

export const reportProductMv = (params: {cid: string; logData: any; }) => {
  const cid = params?.cid;
  const logData = params?.logData;
  Statistics.view(cid, ShopCardProductMv, logData);
};

export const reportProductMc = (params: {cid: string; logData: any; }) => {
  const cid = params?.cid;
  const logData = params?.logData;
  Statistics.setTag && Statistics.setTag('sailor_c', {
    [cid]: {
      ...params,
      bid: ShopCardProductMc,
    },
  });
  Statistics.click(cid, ShopCardProductMc, logData);
};
